import { createFeatureSelector, createSelector } from '@ngrx/store';
import { QueryResultsModel } from '../../_base/crud';
import { ServiceCatalogsState } from '../_reducers/service-catalog.reducers';
import { ServiceCatalogModel } from '../_models/service-catalog.model';

export const selectServiceCatalogsState =
  createFeatureSelector<ServiceCatalogsState>('serviceCatalogs');

export const selectServiceCatalogsPageLoading = createSelector(
  selectServiceCatalogsState,
  (serviceCatalogsState) => serviceCatalogsState.listLoading,
);

export const selectServiceCatalogsActionLoading = createSelector(
  selectServiceCatalogsState,
  (serviceCatalogsState) => serviceCatalogsState.actionsloading,
);

export const selectServiceCatalogError = createSelector(
  selectServiceCatalogsState,
  (serviceCatalogsState) => serviceCatalogsState.error,
);

export const selectServiceCatalogLatestSuccessfullAction = createSelector(
  selectServiceCatalogsState,
  (serviceCatalogsState) => serviceCatalogsState.latestSuccessfullAction,
);

export const selectServiceCatalogsShowInitWaitingMessage = createSelector(
  selectServiceCatalogsState,
  (serviceCatalogsState) => serviceCatalogsState.showInitWaitingMessage,
);

export const selectServiceCatalogsInStore = createSelector(
  selectServiceCatalogsState,
  (serviceCatalogsState) => {
    const items = (serviceCatalogsState.ids as number[])
      .map((id) => serviceCatalogsState.entities[id])
      .filter((item): item is ServiceCatalogModel => item !== undefined);
    return new QueryResultsModel(items, serviceCatalogsState.totalCount);
  },
);
